import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderSlot as _renderSlot, createSlots as _createSlots, normalizeClass as _normalizeClass, withKeys as _withKeys, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-28b2922e")
const _hoisted_1 = ["onKeyup"]
const _hoisted_2 = {
  key: 0,
  class: "fireworks"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "before" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "after" }, null, -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "content-container" }
_popScopeId()

import { ref, watch } from 'vue';

import BalCard from '../BalCard/BalCard.vue';
import useBreakpoints from '@/composables/useBreakpoints';

type Props = {
  show?: boolean;
  title?: string;
  noPad?: boolean;
  noContentPad?: boolean;
  fireworks?: boolean;
};

/**
 * PROPS & EMITS
 */


export default _defineComponent({
  props: {
    show: { type: Boolean, required: false, default: false },
    title: { type: String, required: false, default: '' },
    noPad: { type: Boolean, required: false, default: false },
    noContentPad: { type: Boolean, required: false, default: false },
    fireworks: { type: Boolean, required: false, default: false }
  } as unknown as undefined,
  emits: ['close'],
  setup(__props: {
  show?: boolean;
  title?: string;
  noPad?: boolean;
  noContentPad?: boolean;
  fireworks?: boolean;
}, { expose }) {

const props = __props
const { upToSmallBreakpoint } = useBreakpoints();

/**
 * TYPES
 */




/**
 * STATE
 */
const showContent = ref(false);

/**
 * METHODS
 */
function hide(): void {
  showContent.value = false;
}

// this causes the scrollbar to hide when modal opens which causes the page to jump to left
// watch(
//   () => props.show,
//   () => {
//     if (props.show) {
//       document.body.classList.add('overflow-hidden');
//     } else {
//       document.body.classList.remove('overflow-hidden');
//     }
//   }
// );

/**
 * EXPOSE
 */
expose({ hide });

return (_ctx: any,_cache: any) => {
  return (__props.show)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "bal-modal",
        onKeyup: _withKeys(hide, ["esc"])
      }, [
        _createVNode(_Transition, {
          name: "overlay",
          appear: "",
          onAfterEnter: _cache[0] || (_cache[0] = ($event: any) => (showContent.value = true))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "modal-bg",
              onClick: hide
            }, [
              (__props.fireworks)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_Transition, {
            name: "modal",
            onAfterLeave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
          }, {
            default: _withCtx(() => [
              (showContent.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass({
            contentMobile: _unref(upToSmallBreakpoint),
            content: !_unref(upToSmallBreakpoint),
          })
                  }, [
                    _createVNode(BalCard, {
                      title: __props.title,
                      shadow: "lg",
                      noPad: "",
                      noContentPad: __props.noContentPad,
                      class: "modal-card",
                      noBorder: "",
                      overflowYScroll: ""
                    }, _createSlots({
                      default: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "default")
                      ]),
                      _: 2
                    }, [
                      (_ctx.$slots.header)
                        ? {
                            name: "header",
                            fn: _withCtx(() => [
                              _renderSlot(_ctx.$slots, "header")
                            ])
                          }
                        : undefined,
                      (_ctx.$slots.footer)
                        ? {
                            name: "footer",
                            fn: _withCtx(() => [
                              _renderSlot(_ctx.$slots, "footer")
                            ])
                          }
                        : undefined
                    ]), 1032, ["title", "noContentPad"])
                  ], 2))
                : _createCommentVNode("", true)
            ]),
            _: 3
          })
        ])
      ], 40, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})